import { getLocale, history } from "../../common/helpers";

export const redirectOnLogin = (user) => {
  const currentUser =
    (Array.isArray(user?.user) && user.user[0]) ||
    (user?.user && !Array.isArray(user.user) ? user.user : null) ||
    (Array.isArray(user) && user[0]) ||
    (user && user.roleId ? user : null) ||
    null;

  if (!currentUser) {
    return;
  }

  if (currentUser.roleId === "5655edea-dbfd-4cd3-b985-c347d3be8889") {
    window.location.href += "/stores";
  } else if (currentUser.roleId === "B5C423D2-BC53-11E2-9678-15B654818C3B") {
    window.location.href += "/sys_admin";
  } else {
    const intendedPath = sessionStorage.getItem("postLoginRedirect");
    sessionStorage.removeItem("postLoginRedirect");
    history.push(intendedPath || getLocale(history.location.pathname, true) + "/fc/dashboard");
  }
};

export const formattedLocale = (locale) => {
  switch (locale) {
    case "es-es":
      return "es";
    case "es-mx":
      return "es";
    case "es-la":
      return "es";
    case "es-us":
      return "es";
    case "ja":
      return "en";
    case "no":
      return "en";
    case "ko":
      return "en";
    default:
      return locale;
  }
};
